"use strict";

var _taggedTemplateLiteral = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  flex-grow: 1;\n  text-align: right;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 1;\n  width: 100%;\n  height: 36px;\n  cursor: pointer;\n  border: none;\n  opacity: ", ";\n  color: ", ";\n  background: ", ";\n  padding: 0 16px;\n  outline: none;\n\n  &:hover,\n  &:active {\n    color: ", ";\n    background: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var smooth_scroll_into_view_if_needed_1 = __importDefault(require("smooth-scroll-into-view-if-needed"));

var styled_components_1 = __importStar(require("styled-components"));

var theme_1 = __importDefault(require("../styles/theme"));

function BlockMenuItem(_ref) {
  var selected = _ref.selected,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      title = _ref.title,
      shortcut = _ref.shortcut,
      icon = _ref.icon,
      _ref$containerId = _ref.containerId,
      containerId = _ref$containerId === void 0 ? "block-menu-container" : _ref$containerId;
  var Icon = icon;
  var ref = React.useCallback(function (node) {
    if (selected && node) {
      smooth_scroll_into_view_if_needed_1.default(node, {
        scrollMode: "if-needed",
        block: "center",
        boundary: function boundary(parent) {
          return parent.id !== containerId;
        }
      });
    }
  }, [selected, containerId]);
  return React.createElement(MenuItem, {
    selected: selected,
    onClick: disabled ? undefined : onClick,
    ref: ref
  }, Icon && React.createElement(React.Fragment, null, React.createElement(Icon, {
    color: selected ? theme_1.default.blockToolbarIconSelected : theme_1.default.blockToolbarIcon
  }), "\xA0\xA0"), title, shortcut && React.createElement(Shortcut, null, shortcut));
}

var MenuItem = styled_components_1.default.button(_templateObject(), function (props) {
  return props.disabled ? ".5" : "1";
}, function (props) {
  return props.selected ? props.theme.blockToolbarTextSelected : props.theme.blockToolbarText;
}, function (props) {
  return props.selected ? props.theme.blockToolbarSelectedBackground || props.theme.blockToolbarTrigger : "none";
}, function (props) {
  return props.theme.blockToolbarTextSelected;
}, function (props) {
  return props.selected ? props.theme.blockToolbarSelectedBackground || props.theme.blockToolbarTrigger : props.theme.blockToolbarHoverBackground;
});
var Shortcut = styled_components_1.default.span(_templateObject2(), function (props) {
  return props.theme.textSecondary;
});
exports.default = styled_components_1.withTheme(BlockMenuItem);